<div class="page-container payment-page-container">
  <div class="payment-page-content-wrap">
    <div class="inner-section payment-page-content">

      <div class="payments-form-wrap">
        <div class="tabs-item tab-menu payment">
          <div class="subscription-title">
            {{message}}
          </div>

          <span class="sub-title">
           {{subMessage}}
          </span>
        </div>

        <div class="carousel">
          <span class="donate-title">ВЫ МОЖЕТЕ ПОДДЕРЖАТЬ ДРУГИЕ  АКТУАЛЬНЫЕ СБОРЫ</span>
          <carousel [carouselInfo]="carouselInfo"
                        [customOptions]="customOptions"></carousel>
        </div>

        <div class="payment-monthly">
          <div class="tabs-item tab-card">
            <div class="payment-block payment-card-block-outer">
              <span class="donate-title">РАДАР.НФ</span>
              <span class="sub-title">Скачивайте приложение Радар.НФ, сообщайте спецслужбам об угрозе БПЛА в один клик.Защитите себя и своих близких. <a class="sub-title" href="https://onf.ru/radar">Подробнее</a></span>
            </div>
          </div>
        </div>
        <div class="payment-footer bth-payment">
          <a href="https://pobeda.onf.ru/" class="button">
            вернуться на сайт
          </a>
          <img class="payment-footer-img" src="assets/images/ul-kit/footer-logos.png" alt="">
        </div>
      </div>
    </div>
  </div>
</div>
